exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".achievements-header {\n  color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-direction: row;\n  text-transform: uppercase;\n  font-size: 32px;\n  font-weight: 600;\n  margin: 0 60px; }\n\n.num-completed {\n  font-size: 28px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/screens/profile/ProfileAchievements.scss
// module id = 876
// module chunks = 0